import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Typeahead } from 'react-bootstrap-typeahead';
import { Mixpanel } from '../../redux/Mixpanel';
import {
    Accordion,
    Button,
    Row,
    Col,
    Table,
    Form,
    FormFeedback,
    FormGroup,
    Input
} from 'reactstrap';
import CustomInput from '../../components/CustomInput';
import { colorTheme } from '../../utils/constants';

import {
    check_empty_field,
    check_if_number,
    check_date_field
} from './validationChecks';

import {
    addUnitUtility,
    updateUnitUtility,
    deleteUnitUtility,
    showLoading,
    showFeatureComingSoon,
    addInvoice,
    noTenantinUnit,
    fetchSingleInvoice,
    getTenantInUnit,
    invalidUtilityRate,
    fetchCurrency
} from '../../redux/actions';
import ShowMoreButton from './ShowMoreButton';
import CustomLabel from '../../components/CustomLabel';
import CustomPropertySelect from '../../components/CustomPropertySelect';
import {
    IonInput,
    IonText,
    IonIcon,
    IonButton,
    IonRow,
    IonCol
} from '@ionic/react';
import { trashOutline } from 'ionicons/icons';



const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        unitUtilities: state.unitUtilities,
        tenants: state.tenants,
        invoices: state.invoices,
        currency: state.currency
    };
}

const mapDispatchToProps = {
    addUnitUtility,
    updateUnitUtility,
    deleteUnitUtility,
    showLoading,
    showFeatureComingSoon,
    addInvoice,
    noTenantinUnit,
    fetchSingleInvoice,
    getTenantInUnit,
    invalidUtilityRate,
    fetchCurrency
};


class UtilitiesForm extends React.Component{
    constructor(props){
        super(props);
        let utility = {
            propertyId: this.props.utility? this.props.utility.propertyId : "",
            properties: Object.values(this.props.properties),
            utilityId: "",
            previousReading: "",
            currentReading: "",
            unitDetails: null,
            utilityItem: [],
            invoice:"",
            invoiceId: ""
        };

        this.state = {
            ...utility,
            readOnly: false,
            invoiceOptions:[],
            numErrors: 0,
            date: this.props.utility? this.props.utility.date : null,
            showOptionalFields: false,
            utilityItemOptions: ["water", "electricity"],
            unit: [],
            unitOptions: [],
            errors: {
                currentReading: "",
                previousReading: "",
                utilityItem: "",
                unit: "",
                date: ""
            }
        };
    }

    async componentDidMount(){
        if(_.isEmpty(this.props.currency)){
            this.props.showLoading(true);
            await this.props.fetchCurrency();
        }
        if (this.props.utility){
            await this.setUnitOptions(this.props.utility.propertyId);
            const utility = this.props.unitUtilities[this.props.utility.invoiceId];
            const utilityState = {
                ...this.props.utility,
                utilityItem: [this.props.utility.item],
                unitId: this.props.utility.unit,
                showOptionalFields: true,
                unit: [this.getUnitOption(this.props.units[this.props.utility.unit])],
                readOnly: (
                    this.props.utility.invoiceId != "" ||
                    (utility && utility.invoiceId != "")
                )
            };
            this.setState({...utilityState}, () => {
                if(this.props.action == "generateInvoice"){
                    this.handleGenerateInvoice(null);
                }
            });
        }else{
            this.setState({
                properties: Object.values(this.props.properties)
            });
            if(Object.values(this.props.properties).length === 1){
                let propertyId = Object.values(this.props.properties)[0].propertyId;
                this.setUnitOptions(propertyId);
                this.setState({ propertyId });
            }
        }
        // Mixpanel.track("Utilities form: mounted");
    }


    async validateInput(name, value){
        let val = String(value);
        let isValid = true;
        let checks = [];

        switch(name){
            case "unit":
                checks = [check_empty_field];
                break;
            case "previousReading":
                checks = [check_if_number];
                break;
            case "currentReading":
                checks = [check_empty_field, check_if_number];
                break;

            case "utilityItem":
                checks = [check_empty_field];
                break;
            case "date":
                checks = [check_date_field, check_empty_field];
                break;
            default:
                break;
        }

        await this.setState((prevState) => {
            let errors = {...prevState.errors};
            let numErrors = prevState.numErrors;
            for (let index in checks){
                let previousError = prevState.errors[name];
                errors[name] = checks[index](val);

                if (errors[name].length > 0){
                    if (previousError.length == 0){
                        numErrors += 1
                    }
                    isValid = false;
                    break;
                }else if(previousError.length > 0){
                    numErrors -= 1
                }
            }
            return {
               errors,
               numErrors
            };
        });
        return isValid;
    }

    handleChange(event) {
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val});

        this.validateInput(name, val);
    }

    handleChangeDate(name, value){
        this.setState((prevState) => {
            let date = (name == "date")? value: prevState.date;
            this.validateInput(name, value)
            return { date };
        });
    }

    getUnitOption(unit){
        if (unit){
            return {
                id: unit.unitId,
                unitDetails: unit,
                label: unit.unitName
            };
        }{
            return null;
        }
    }

    async setUnitOptions(propertyId=""){
        let unitOptions = [];

        if(propertyId){
            const unitIds = Object.keys(this.props.properties[propertyId]["units"])
            for(let iid of unitIds){
                unitOptions.push(this.getUnitOption(this.props.units[iid]))
            }

        }
        let selectedUnit = this.getUnitOption(this.state.unitDetails);
        this.setState({
            unitOptions,
            unit: selectedUnit? [selectedUnit] : []
        });
    }

    async handleSelectProperty(event){
        event.preventDefault();
        let value = event.target.value;
        if(this.state.propertyId != value){
            this.setUnitOptions(value);
        }
        this.setState({
            propertyId: value,
            unitDetails: null,
            unit: []
        })
    }


    async handleSubmit(event) {
        event.preventDefault();
        let fields = ["unit", "previousReading", "currentReading", "utilityItem", "date"];
        let results = [];
        let field;
        for(field of fields){
            let isValid = await this.validateInput(field, this.state[field])
            results.push(isValid);
        }
        let invalid_fields = results.filter( (x) => !x);

        if (this.state.propertyId != "" && this.state.unit.length > 0 && invalid_fields.length == 0) {
            let unitUtilityObj = {
                unitId: this.state.unit[0].unitDetails.unitId,
                date: this.state.date,
                item: this.state.utilityItem,
                currentReading: this.state.currentReading,
                previousReading: this.state.previousReading,
                invoiceId: this.state.invoiceId
            }
            this.props.showLoading(true);
            let result;
            if (this.state.utilityId == "") {
                result = await this.props.addUnitUtility(unitUtilityObj);
                if(result && result.payload && result.payload.unitUtility){
                    let utility = result.payload.unitUtility;
                    this.setState({
                        utilityId: utility.utilityId,
                        previousReading: utility.previousReading
                    });
                }
            }else{
                this.props.updateUnitUtility({
                    ...unitUtilityObj,
                    utilityId: this.state.utilityId
                });
            }
        }
        Mixpanel.track("Utilities form: submit btn");

    }


    setUtilityValues(
        unit=[], utilityId="", previousReading="",
        currentReading="", date=null, readOnly=false
    ){
            window.scrollTo(0, 0);
            this.setState({
                unit, utilityId, previousReading,
                currentReading, readOnly,
                date: date? date: new Date()
            })
    }

    async handleChangedOptions(name, selected){
        this.setState({[name]: selected});
        this.validateInput(name, selected);
    }

    async handleDelete(event) {
        event.preventDefault();
        const confirmDelete = window.confirm("Are you sure you want to delete this utility?");

        if (confirmDelete) {
            this.props.showLoading(true);
            let result = await this.props.deleteUnitUtility(this.state.utilityId);
            if (result && !result.errors) {
                this.setUtilityValues();
            }
            Mixpanel.track("Utilities form: delete btn");
        }
    }

    handleCancelUpdate(event){
        event.preventDefault();
        this.setUtilityValues();
        Mixpanel.track("Utilities form: cancel update btn");
    }

    handleClear(event){
        event.preventDefault();
        this.setUtilityValues();
        Mixpanel.track("Utilities form: clear btn");
    }

    async getTenant(unitId){
        let tenant;
        this.props.showLoading(true);
        let action = await this.props.getTenantInUnit(unitId);
        if (action.payload && action.payload.tenant){
            tenant = action.payload.tenant;
        }
        return tenant;
    }

    async handleGenerateInvoice(event){
        if(event){
            event.preventDefault();
        }
        let tenant = await this.getTenant(this.state.unit[0].unitDetails.unitId);

        if (tenant && tenant.tenantId){
            let diff = this.state.currentReading - this.state.previousReading;
            let utilityToEdit = this.props.unitUtilities[this.state.utilityId];
            this.props.updateUnitUtilityObj(utilityToEdit);
            let propertyId = tenant.propertyId;
            let rate;
            if (this.state.utilityItem == "water"){
                rate = this.props.properties[propertyId].waterRate
            } else if(this.state.utilityItem == "electricity"){
                rate = this.props.properties[propertyId].electricityRate
            }

            if (rate == 0){
                this.props.invalidUtilityRate();
            } else {
                const amount = (diff * rate).toFixed(2);
                const item = this.state.utilityItem[0];
                const description = `Previous reading: ${this.state.previousReading}. Current reading: ${this.state.currentReading}. Unit rate: ${rate} ${this.props.currency.customerCurrency}/Unit`;
                let invoice = {
                    tenantDetails: tenant,
                    propertyId: propertyId,
                    amount,
                    memo: "",
                    item,
                    invoiceItems: [{itemName: item, amount: amount, description: description}],
                    status: "open",
                    invoiceDate: new Date(),
                    utilityId: this.state.utilityId,
                    combineWithOtherInvoices: true
                };

                this.props.changeTab("", invoice);
            }
        }else{
            this.props.noTenantinUnit();
        }
        Mixpanel.track("Utilities form: generate invoice btn");
    }

    async fetchInvoice(invoiceId){
        this.props.showLoading(true);
        const action = await this.props.fetchSingleInvoice(invoiceId);
    }

    async handleShowInvoice(event){
        event.preventDefault();
        if (this.state.invoiceId && !(this.props.invoices.hasOwnProperty(this.state.invoiceId))){
            await this.fetchInvoice(this.state.invoiceId);
            this.props.changeTab(this.state.invoiceId);
        }else if(this.state.invoiceId && (this.props.invoices.hasOwnProperty(this.state.invoiceId))){
            this.props.changeTab(this.state.invoiceId)
        }else if(this.state.utilityId && (this.props.invoices.hasOwnProperty(this.props.unitUtilities[this.state.utilityId].invoiceId))){
            this.props.changeTab(this.props.unitUtilities[this.state.utilityId].invoiceId)
        }
        else{
            await this.fetchInvoice(this.props.unitUtilities[this.state.utilityId].invoiceId)
            this.props.changeTab(this.props.unitUtilities[this.state.utilityId].invoiceId)
        }
        Mixpanel.track("Utilities form: show invoice btn");
    }

    renderRequiredFields(){
        return (
            <React.Fragment>
                {/* Select Property and Unit */}
                <FormGroup row>
                    <CustomLabel for="propertyId">
                        Select Property
                    </CustomLabel>

                    {/* <Col sm={12} md={8} className=""> */}
                        {/* <Row> */}
                            <Col style={{maxWidth: '250px'}} xs={12} sm={12} md={8}>
                                <CustomInput
                                    type="select"
                                    name="propertyId"
                                    id="propertyId"
                                    disabled={this.state.readOnly}
                                    onChange= {this.handleSelectProperty.bind(this)}
                                    value={this.state.propertyId}
                                >
                                    <CustomPropertySelect propertiesArray={this.state.properties}/>
                                </CustomInput>
                            </Col>

                </FormGroup>

                <FormGroup row>

                    <CustomLabel for="unit">
                        Select Unit
                    </CustomLabel>

                            {/* Select Unit */}
                            <Col className="" style={{maxWidth: '250px'}} xs={12} sm={12} md={8}>
                                <Typeahead
                                    emptyLabel={this.state.utilityId=="" ? "Please first select property." : "Choose Unit. No matches found."}
                                    disabled={this.state.readOnly}
                                    id="unit"
                                    clearButton
                                    options={this.state.unitOptions}
                                    name="unit"
                                    selected={this.state.unit}
                                    onChange={this.handleChangedOptions.bind(this, "unit")}
                                >
                                </Typeahead>
                                {this.state.errors.unit.length > 0 && <p className="text-danger">
                                    {this.state.errors.unit}
                                </p>}
                            </Col>
                </FormGroup>

                {/* Utility Item */}
                <FormGroup row>
                    <CustomLabel for="utilityItem">
                        Utility Item
                    </CustomLabel>
                    <Col style={{maxWidth: '250px'}} sm={12} md={8}>
                        <Typeahead
                            clearButton
                            disabled={this.state.readOnly}
                            id="utilityItem"
                            options={this.state.utilityItemOptions}
                            name="utilityItem"
                            selected={this.state.utilityItem}
                            onChange={this.handleChangedOptions.bind(this, "utilityItem")}
                        >
                        </Typeahead>
                        {this.state.errors.utilityItem.length > 0 &&
                            <p className="text-danger">{this.state.errors.utilityItem}</p>
                        }
                    </Col>
                </FormGroup>

                {/* Current Reading */}
                <FormGroup row>
                    <CustomLabel for="currentReading">
                        Current Reading
                    </CustomLabel>
                        <Col style={{maxWidth: '250px'}} sm={12} md={8}>
                            <Input
                                id="currentReading"
                                name="currentReading"
                                placeholder='Current Reading ...'
                                disabled={this.state.readOnly}
                                value={this.state.currentReading}
                                onChange={this.handleChange.bind(this)}
                                invalid={this.state.errors.currentReading.length > 0}
                            />
                            <FormFeedback>{this.state.errors.currentReading}</FormFeedback>
                        </Col>
                </FormGroup>

                {/* Month / Year */}
                <FormGroup row>
                    <CustomLabel for="date">
                        Date
                    </CustomLabel>
                    <Col style={{maxWidth: '250px'}} sm={12} md={8}>
                        <IonInput
                            type="date"
                            fill="solid"
                            value={this.state.date}
                            disabled={this.state.readOnly}
                            onIonChange={(e) => {
                                this.handleChangeDate("date", e.target.value);
                            }}
                        />
                        {this.state.errors.date.length > 0 && <p className="text-danger">{this.state.errors.date}</p>}
                    </Col>
                </FormGroup>
            </React.Fragment>
        );
    }

    renderOptionalFields(){
        return (
            <React.Fragment>
                {/* Previous Reading */}
                <FormGroup row>
                    <CustomLabel for="previousReading">
                        Previous Reading <br/> (optional)
                    </CustomLabel>
                    <Col style={{maxWidth: '250px'}} sm={12} md={8}>
                        <Input
                            id="previousReading"
                            name="previousReading"
                            placeholder='Previous Reading'
                            disabled={this.state.readOnly}
                            value={this.state.previousReading}
                            onChange={this.handleChange.bind(this)}
                            invalid={this.state.errors.previousReading.length > 0}
                        />
                        {!this.state.utilityId && (<p>if left blank, defaults to  previously recorded reading (if previous recorded reading exists).</p>)}
                        <FormFeedback>{this.state.errors.previousReading}</FormFeedback>
                    </Col>
                </FormGroup>

            </React.Fragment>
        )
    }

    renderButtons(){
        return  (
            <Row className="d-flex mb-4 pb-3 border-bottom border-dark justify-content-center">
                <IonButton
                    type="submit"
                    style={{width:"80%"}}
                    className="shadow py-1"
                    id="saveBtn"
                    disabled={this.state.readOnly || this.state.propertyId == "" || this.state.unit.length == 0 || this.state.numErrors > 0}>
                    {this.state.utilityId?
                        <span><i className="fa fa-fw fa-refresh mr-1"></i>Update Utility</span>:
                        <span><i className="fa fa-fw fa-plus mr-1"></i>Add Utility</span>}
                </IonButton>

                {this.state.utilityId && (
                <IonButton type="submit"
                    style={{ width: "80%" }}
                    className="mt-3 py-1"
                    fill='outline'
                    onClick={this.handleClear.bind(this)}
                >
                    <span><i className="fa fa-fw fa-plus mr-1"></i>Add Another Utility</span>
                </IonButton>)}
            </Row>);
    }

    renderHeaderButtons() {
        return (
            <IonRow className="ion-justify-content-end">
                <IonCol size="auto">
                    {(this.state.utilityId !== "" && this.props.unitUtilities[this.state.utilityId] &&
                        this.props.unitUtilities[this.state.utilityId].invoiceId === "") && (
                            <IonButton
                                color="medium"
                                className="mx-2 shadow mt-1"
                                size="small"
                                onClick={this.handleGenerateInvoice.bind(this)}
                            >
                                Generate Invoice
                            </IonButton>)}

                    {(this.state.utilityId !== "" && this.props.unitUtilities[this.state.utilityId] &&
                        this.props.unitUtilities[this.state.utilityId].invoiceId !== "") && (
                            <IonButton
                                className="mx-2 shadow mt-1"
                                color="medium"
                                size="small"
                                onClick={this.handleShowInvoice.bind(this)}
                            >
                                Show Invoice
                            </IonButton>)}

                    {this.state.utilityId && (
                        <IonButton
                            type="submit"
                            color="medium"
                            id="deleteButton"
                            className="mx-2 shadow mt-1"
                            size="small"
                            disabled={this.state.readOnly}
                            onClick={this.handleDelete.bind(this)}
                        >
                            <IonIcon icon={trashOutline} />
                        </IonButton>
                    )}
                </IonCol>
            </IonRow>
        );
    }

    render(){
        return (
            <Col>
                <Row className="mb-2">
                    {!this.state.utilityId && <Col style={{minWidth:'300px'}} lg={9} md={8} sm={7} xs={6}>
                        <IonText>Use this form to save utility (water / electricity) readings.</IonText>
                    </Col>}
                        {this.renderHeaderButtons()}
                </Row>
                <Row>
                    <Col lg={12}>
                    {this.state.readOnly && (<Row className="my-2 mb-2">
                        <Col lg={12}>
                            <h6 style={{color:'red'}} >
                                Cannot EDIT/DELETE this utility. To EDIT/DELETE this utility please first delete
                                the generated <a style={{textDecorationLine: 'underline', color:'blue'}} onClick={(e)=>this.handleShowInvoice(e)}>invoice</a>.
                            </h6>
                        </Col>
                    </Row>)}

                    <Form onSubmit={this.handleSubmit.bind(this)}>
                        {this.renderRequiredFields()}

                        <ShowMoreButton
                            id="showOptionalFields"
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState((prevState) => ({showOptionalFields: !prevState.showOptionalFields}))
                            }}
                            showMore={this.state.showOptionalFields}
                        />

                        {this.state.showOptionalFields && this.renderOptionalFields()}

                        {this.renderButtons()}

                    </Form>
                    </Col>
                </Row>

            </Col>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UtilitiesForm);